(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSAsignacion', SSAsignacion);

    SSAsignacion.$inject = ['$resource', 'DateUtils'];

    function SSAsignacion ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-asignacions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.iniPrestacion = DateUtils.convertDateTimeFromServer(data.iniPrestacion);
                        data.finPrestacion = DateUtils.convertDateTimeFromServer(data.finPrestacion);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                        data.fechaLiberacion = DateUtils.convertDateTimeFromServer(data.fechaLiberacion);
                    }
                    return data;
                }
            },
            'getById': {
                method: 'GET',
            	url:'api/s-s-asignacion/liberacion/:id',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.iniPrestacion = DateUtils.convertDateTimeFromServer(data.iniPrestacion);
                        data.finPrestacion = DateUtils.convertDateTimeFromServer(data.finPrestacion);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                        data.fechaLiberacion = DateUtils.convertDateTimeFromServer(data.fechaLiberacion);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'liberar': { 
            	method: 'GET', 
            	url:'api/s-s-asignacions/liberacion/:idAsignacion/:numExpediente',
            	isArray: false
           	},
            'cancelarBaja': { 
            	method: 'GET', 
            	url:'api/s-s-asignacions/cancelar-baja/:idAsignacion',
            	isArray: false
           	},
            'cancelarAsignacion': { 
            	method: 'GET', 
            	url:'api/s-s-asignacions/cancelar-asignacion/:idAsignacion',
            	isArray: false
           	},
            'darDeBaja': { 
            	method: 'POST', 
            	url:'api/s-s-asignacions/baja'
           	},
            'asignar': { 
            	method: 'POST', 
            	url:'api/s-s-asignacions/asignacion'
           	},
            'cambiarFechas': { 
            	method: 'PUT', 
            	url:'api/s-s-asignacions/cambiarFechas'
           	},
            'cambiarFechasAdmin': { 
            	method: 'PUT', 
            	url:'api/s-s-asignacions/fechas'
           	},
			'cancelarLiberacion': { 
			    method: 'PUT', 
			    url:'api/s-s-asignacions/cancelar-liberacion'
			},
            'validarStatusAlumno': { 
            	method: 'GET', 
            	url:'api/s-s-asignacions/validarStatusAlumno/:idAsignacion',
           		isArray: false
           	}, 
        });
    }
})();
